import service from "@/utils/request";
// 点名详情
export const rollCallDetails = (params: { roll_call_id: number }) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/detail",
    method: "get",
    params,
  });
};
//课次点名详情
export const lessonDetails = (params: { lesson_id: number }) => {
  return service({
    url: "/api/v1/class/lesson/detail",
    method: "get",
    params,
  });
};
//提交点名
export const lessonRollCall = (data: {
  lesson_id: number;
  student_list: [];
}) => {
  return service({
    url: "/api/v1/class/lesson/roll_call",
    method: "post",
    data,
  });
};
//课次点名临时列表
export interface selectListData {
  page: number;
  page_size: number;
  original_class_id?: number;
  lesson_id?: number;
  in_roll_call?: boolean;
  roll_call_id?: number;
  course_id?: number;
  class_id?: number;
}
export const studentselectList = (params: selectListData) => {
  return service({
    url: "/api/v1/class/student/select_list",
    method: "get",
    params,
  });
};
//课次学员添加
export const studentListAdd = (data: {
  lesson_id: number;
  student_type: number;
  in_roll_call: boolean;
  student_list: [];
}) => {
  return service({
    url: "/api/v1/class/lesson/student/add",
    method: "post",
    data,
  });
};
